import { render, staticRenderFns } from "./AssignDep.vue?vue&type=template&id=028aef76&scoped=true&"
import script from "./AssignDep.vue?vue&type=script&lang=js&"
export * from "./AssignDep.vue?vue&type=script&lang=js&"
import style0 from "./AssignDep.vue?vue&type=style&index=0&id=028aef76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028aef76",
  null
  
)

export default component.exports